export const HomeBannerContent = {
  bannerHeading: "Yum Canal",
  bannerSmallText: "The Family Restaurant",
  bannerButtonText: "Order Online",
  bannerTaglineText : "Where taste flows to your plate"
};
